import { first } from 'lodash';

import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';
import recurrenceRuleSet from 'utils/recurrence/recurrenceRuleSet.util';

const L = logger('recurrenceFirstRule');

const recurrenceFirstRule = withOptions((options) => {
  try {
    const { _rrule: rRules } = recurrenceRuleSet(options);
    return first(rRules);
  } catch (e) {
    L.error('()', 'for options:', options, 'error:', e);
    return null;
  }
});

export default recurrenceFirstRule;
